import { render, staticRenderFns } from "./BulkDeleteDialog.vue?vue&type=template&id=1962ad7e"
import script from "./BulkDeleteDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulkDeleteDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports